import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';

const STATUS_COLOR = {
  'Baru': '#4e73df', 'Dalam Proses': '#f6c23e', 'Selesai': '#1cc88a',
  'Dipulangkan': '#36b9cc', 'Menunggu Maklumbalas': '#858796', 'Waiting to Pickup': '#343a40',
};

function fmtTime(unix) {
  if (!unix) return '';
  const d = new Date(parseInt(unix) * 1000);
  return d.toLocaleString('en-MY', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
}

function ItemRow({ code, custid, status, time, onClick }) {
  return (
    <div onClick={onClick} style={{ padding: '10px 16px', borderBottom: '1px solid #f8f8f8', cursor: 'pointer' }}
      onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
      onMouseLeave={e => e.currentTarget.style.background = ''}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
        <span style={{ fontSize: 12, fontWeight: 500, color: '#1a1a2e' }}>{code}</span>
        <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 10, background: STATUS_COLOR[status] || '#858796', color: '#fff' }}>
          {status}
        </span>
      </div>
      <div style={{ fontSize: 11, color: '#aaa' }}>{custid} · {fmtTime(time)}</div>
    </div>
  );
}

export default function NotificationInbox() {
  const { jobs, warranty, inboxUnread, markInboxRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handler(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  function toggle() {
    setOpen(v => !v);
    if (!open) markInboxRead();
  }

  function goTo(path) {
    setOpen(false);
    navigate(path);
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={toggle} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', position: 'relative', color: '#6c757d', display: 'flex', alignItems: 'center' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        {inboxUnread > 0 && (
          <span style={{ position: 'absolute', top: 0, right: 2, width: 8, height: 8, borderRadius: '50%', background: '#e74a3b', border: '1.5px solid #fff' }} />
        )}
      </button>

      {open && (
        <div style={{ position: 'absolute', right: 0, top: '110%', width: 340, background: '#fff', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 1000, overflow: 'hidden' }}>

          {/* Jobs section */}
          <div style={{ padding: '10px 16px 6px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12, fontWeight: 500, color: '#4e73df', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Latest Jobs</span>
            <span style={{ fontSize: 11, color: '#aaa' }}>{jobs.length}</span>
          </div>
          {jobs.length === 0
            ? <div style={{ padding: '12px 16px', fontSize: 12, color: '#bbb' }}>No jobs</div>
            : jobs.map((j, i) => (
                <ItemRow key={j.jobcode || i} code={j.jobcode} custid={j.custid} status={j.status} time={j.time}
                  onClick={() => goTo(`/jobs/${j.jobcode}/edit`)} />
              ))
          }

          {/* Warranty section */}
          <div style={{ padding: '10px 16px 6px', borderTop: '2px solid #f4f6f8', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12, fontWeight: 500, color: '#f6c23e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Latest Warranty</span>
            <span style={{ fontSize: 11, color: '#aaa' }}>{warranty.length}</span>
          </div>
          {warranty.length === 0
            ? <div style={{ padding: '12px 16px', fontSize: 12, color: '#bbb' }}>No warranty claims</div>
            : warranty.map((w, i) => (
                <ItemRow key={w.jobcode || i} code={w.jobcode} custid={w.custid} status={w.status} time={w.time}
                  onClick={() => goTo(`/warranty/${w.jobcode}/edit`)} />
              ))
          }
        </div>
      )}
    </div>
  );
}
